"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderSliderElement = void 0;
var react_1 = __importDefault(require("react"));
var HeaderSliderElement_module_scss_1 = __importDefault(require("./HeaderSliderElement.module.scss"));
var react_router_dom_1 = require("react-router-dom");
var HeaderSliderElement = function (props) {
    var imgPath = props.imgPath, title = props.title, descriptionStroke = props.descriptionStroke, linkPath = props.linkPath;
    return (react_1.default.createElement("div", { className: HeaderSliderElement_module_scss_1.default.slide },
        react_1.default.createElement("div", { className: HeaderSliderElement_module_scss_1.default.slide__insert },
            react_1.default.createElement("h2", { className: HeaderSliderElement_module_scss_1.default.slide__title }, title),
            react_1.default.createElement("p", { className: HeaderSliderElement_module_scss_1.default.slide__description }, descriptionStroke.map(function (stroke, index, array) {
                return (react_1.default.createElement(react_1.default.Fragment, { key: index },
                    stroke,
                    " ",
                    index !== array.length - 1 ? react_1.default.createElement("br", null) : ''));
            })),
            react_1.default.createElement(react_router_dom_1.Link, { className: HeaderSliderElement_module_scss_1.default.slide__link, to: linkPath })),
        react_1.default.createElement("picture", { className: HeaderSliderElement_module_scss_1.default.slide__picture },
            react_1.default.createElement("img", { fetchPriority: "high", className: HeaderSliderElement_module_scss_1.default.slide__img, src: imgPath, alt: "car slider image" }))));
};
exports.HeaderSliderElement = HeaderSliderElement;
